import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClaimDisputeStatus } from 'src/app/sakp/model/departure-claim';
import { ViolationTooltipData } from 'src/app/shared/model/violation-tooltip-data';
import { UserService } from 'src/app/sakp/services/user.service';
import { ViolationService } from 'src/app/sakp/services/violations.service';
import { colorizeDisputeStatusBackground } from 'src/app/sakp/util/css-utils';


@Component({
  selector: 'app-violations-marker',
  templateUrl: './violations-marker.component.html',
  styleUrls: ['./violations-marker.component.scss']
})
export class ViolationsMarkerComponent {

  @Output()
  violationClicked = new EventEmitter<number>();
  @Input()
  private claims: Record<number, ClaimDisputeStatus>;
  @Input()
  private claimsDate: Date | null;


  constructor(
    private violationService: ViolationService,
    private translateService: TranslateService,
    private userService: UserService
  ) { }


  getViolations(): number[] {
    return this.claims != null ? Object.keys(this.claims).map(Number) : [];
  }

  colorize(violation: number): string {
    const myUserInfo = this.userService.getMyInfo();
    const status = this.claims[violation];
    if (status === ClaimDisputeStatus.DRAFT && !myUserInfo.canViewDrafts)
      return 'sakp-red-background';
    return colorizeDisputeStatusBackground(status);
  }

  createViolationTooltipData(violation: number): ViolationTooltipData {
    if (this.claimsDate == null) {
      console.error('null createdAt Date');
      return undefined;
    }
    const violations = this.violationService.getByDate(this.claimsDate);
    if (violations == null) {
      console.error('null violations');
      return undefined;
    }
    const thisViolation = violations.getViolationById(violation);
    if (!thisViolation) return {name: 'unknown'};

    const currentLang = this.translateService.currentLang || 'en';
    const name = thisViolation.i18n?.[currentLang]?.name || thisViolation.name || 'unknown';
    const description = thisViolation.i18n?.[currentLang]?.desc || thisViolation.description;
    const originalStatus = this.claims[violation];
    const status = originalStatus ? this.translateService.instant(`sakp.disputes.summary.item.dispute-status.${originalStatus}`) : undefined;
    return { name, status, description };
  }

  getViolationSymbol(idViolation: number): string {
    const violations = this.violationService.getByDate(this.claimsDate);
    if (!violations) return idViolation + '';
    const violation = violations.getViolationById(idViolation);
    return violation?.symbol ?? idViolation + ''; // TODO: obsługa ewentualnych nadpisań z violation.i18n
  }
}
